var map = {
	"./carousel.gif": 3027,
	"./clock.gif": 4527,
	"./customer.gif": 7885,
	"./fireAlarm.gif": 1927,
	"./handshake.gif": 6919,
	"./handshakeDeal.gif": 4635,
	"./list.gif": 3778,
	"./minimal.gif": 9227,
	"./omnichannel.gif": 8163,
	"./review.gif": 6367,
	"./rocket.gif": 8093,
	"./settings.gif": 2106,
	"./thumbupLightBlue.gif": 9618,
	"./thumbupoutlineBej.gif": 9488,
	"./thumbupoutlineBlack.gif": 1620,
	"./thumbupoutlineBlue.gif": 9764,
	"./thumbupoutlineGreen.gif": 586,
	"./thumbupoutlineLightGreen.gif": 1421,
	"./thumbupoutlineLightPink.gif": 2759,
	"./thumbupoutlinePink.gif": 5728,
	"./thumbupoutlineRed.gif": 3064,
	"./thumbupoutlineYellow.gif": 862,
	"./user.gif": 4173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 800;